(function () {
  var root = document.querySelector('.acl[data-acl-campaign]');
  if (!root) return;
  var CID = root.getAttribute('data-acl-campaign') || 'collab';
  var CNAME = root.getAttribute('data-acl-campaign-name') || CID;
  var STAMP = root.getAttribute('data-acl-stamp') === 'true';
  var qs = new URLSearchParams(window.location.search);
  var utm = {};
  ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'].forEach(function (k) { var v = qs.get(k); if (v) utm[k] = v.slice(0, 100); });
  var device = window.innerWidth < 750 ? 'mobile' : (window.innerWidth < 1100 ? 'tablet' : 'desktop');
  var visibleMs = 0, visibleSince = document.visibilityState === 'visible' ? Date.now() : 0;
  function clean(o) { var r = {}; Object.keys(o || {}).forEach(function (k) { if (o[k] !== undefined && o[k] !== null && o[k] !== '') r[k] = o[k]; }); return r; }
  function send(name, props) {
    var p = clean(Object.assign({ campaign_id: CID, campaign_name: CNAME, device: device }, utm, props || {}));
    var ev = 'edit_' + name;
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(ev, p); } catch (e) {}
    try { window.dataLayer = window.dataLayer || []; window.dataLayer.push(Object.assign({ event: ev }, p)); } catch (e) {}
    try { if (typeof window.gtag === 'function') window.gtag('event', ev, p); } catch (e) {}
    try { if (typeof window.fbq === 'function') window.fbq('trackCustom', 'Edit_' + name, p); } catch (e) {}
    if (KLAVIYO[name]) {
      try {
        var kp = Object.assign({}, p);
        if (window.klaviyo && typeof window.klaviyo.track === 'function') window.klaviyo.track(KLAVIYO[name], kp);
        else if (window._learnq && window._learnq.push) window._learnq.push(['track', KLAVIYO[name], kp]);
      } catch (e) {}
    }
  }
  var KLAVIYO = { page_view: 'Viewed Collab Page', add_to_bag: 'Added to Bag from Collab Page' };
  send('page_view', { referrer: document.referrer ? new URL(document.referrer).hostname : 'direct', landing_path: window.location.pathname });
  function stampCart() {
    if (!STAMP) return;
    var key = 'acl_stamp_' + CID;
    try { if (sessionStorage.getItem(key)) return; } catch (e) {}
    var attrs = { 'Campaign': CNAME, 'Campaign ID': CID, 'Campaign landing': new Date().toISOString().slice(0, 16).replace('T', ' ') };
    if (utm.utm_source) attrs['UTM source'] = utm.utm_source;
    if (utm.utm_medium) attrs['UTM medium'] = utm.utm_medium;
    if (utm.utm_campaign) attrs['UTM campaign'] = utm.utm_campaign;
    if (utm.utm_content) attrs['UTM content'] = utm.utm_content;
    var rootUrl = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(rootUrl + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: attrs }) })
      .then(function (r) { if (r.ok) { try { sessionStorage.setItem(key, '1'); } catch (e) {} } })
      .catch(function () {});
  }
  stampCart();
  var marks = [25, 50, 75, 90], hit = {}, maxScroll = 0;
  function onScroll() {
    var rect = root.getBoundingClientRect();
    var total = rect.height - window.innerHeight;
    var pct = total > 0 ? Math.min(100, Math.max(0, Math.round((-rect.top / total) * 100))) : 100;
    if (pct > maxScroll) maxScroll = pct;
    marks.forEach(function (m) { if (pct >= m && !hit[m]) { hit[m] = 1; send('scroll', { percent: m }); } });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  function label(el) {
    if (el.classList.contains('acl-hero')) return { section: 'banner' };
    if (el.classList.contains('acl-rail')) return { section: 'product rail' };
    if (el.classList.contains('acl-note')) { var t = el.querySelector('.acl-note__text'); return { section: 'quote', detail: t ? t.textContent.trim().slice(0, 60) : '' }; }
    if (el.classList.contains('acl-sl')) { var g = el.querySelector('.acl-sl__tag'); return { section: 'look', look: g ? g.textContent.trim() : '' }; }
    if (el.classList.contains('acl-tiles')) { var h = el.querySelector('.acl-h2'); return { section: 'creator tiles', detail: h ? h.textContent.trim() : '' }; }
    if (el.classList.contains('acl-head--block')) { var h2 = el.querySelector('.acl-h2'); return { section: 'heading', detail: h2 ? h2.textContent.trim() : '' }; }
    return { section: 'other' };
  }
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { send('section_view', label(en.target)); io.unobserve(en.target); }
      });
    }, { threshold: 0.5 });
    root.querySelectorAll('.acl-hero, .acl-rail, .acl-note, .acl-sl, .acl-tiles, .acl-head--block').forEach(function (el) { io.observe(el); });
  }
  function handleFrom(el) {
    if (!el) return '';
    var h = el.getAttribute && (el.getAttribute('data-acl-qs') || el.getAttribute('data-h'));
    if (h) return h;
    var href = el.getAttribute && el.getAttribute('href');
    var part = href ? href.split('/products/')[1] : null;
    return part ? part.split(/[?#]/)[0] : '';
  }
  function lookOf(el) { var sl = el.closest('.acl-sl'); var g = sl && sl.querySelector('.acl-sl__tag'); return g ? g.textContent.trim() : ''; }
  function areaOf(el) {
    if (el.closest('.acl-rail')) return 'product rail';
    if (el.closest('.acl-tiles')) return 'creator tiles';
    if (el.closest('.acl-sl')) return 'look';
    if (el.closest('.acl-hero')) return 'banner';
    if (el.closest('.acl-qs')) return 'quick shop drawer';
    return 'page';
  }
  document.addEventListener('click', function (e) {
    var t = e.target;
    var el;
    if ((el = t.closest('.acl-qs__add'))) return send('add_to_bag_click', { items_selected: document.querySelectorAll('.acl-qs__item:not(.is-off)').length });
    if ((el = t.closest('.acl-qs__chip'))) {
      var item = el.closest('.acl-qs__item'), lab = el.closest('.acl-qs__opt').querySelector('.acl-qs__lab span');
      return send('option_select', { product: item ? item.getAttribute('data-h') : '', option: lab ? lab.firstChild.textContent.trim() : '', value: el.getAttribute('data-val'), sold_out: el.disabled ? 'yes' : 'no' });
    }
    if ((el = t.closest('.acl-qs__sg'))) { var it = el.closest('.acl-qs__item'); return send('size_guide_open', { product: it ? it.getAttribute('data-h') : '' }); }
    if ((el = t.closest('.acl-qs__pdp, .acl-qs__img'))) return send('view_full_details', { product: handleFrom(el.closest('.acl-qs__item')) });
    if ((el = t.closest('.acl-qs__check'))) { var ci = el.closest('.acl-qs__item'); var inp = el.querySelector('input'); return setTimeout(function () { send('item_toggle', { product: ci ? ci.getAttribute('data-h') : '', included: inp && inp.checked ? 'yes' : 'no' }); }, 0); }
    if ((el = t.closest('.acl-qs [data-qs-close]'))) return send('quick_shop_close', { added: 'no' });
    if ((el = t.closest('.acl-sl__cta'))) return send('shop_look_open', { look: lookOf(el), products: el.getAttribute('data-acl-qs') });
    if ((el = t.closest('.acl-hs__dot'))) { var hs = el.closest('.acl-hs'); var pop = hs && hs.querySelector('.acl-hs__pop'); return send('hotspot_tap', { look: lookOf(el), product: handleFrom(pop) }); }
    if ((el = t.closest('.acl-hs__pop'))) return send('quick_add_open', { source: 'hotspot', look: lookOf(el), product: handleFrom(el) });
    if ((el = t.closest('.acl-card__qa'))) return send('quick_add_open', { source: 'product rail', product: handleFrom(el) });
    if ((el = t.closest('.acl-mini'))) return send('quick_add_open', { source: areaOf(el), look: lookOf(el), product: handleFrom(el) });
    if ((el = t.closest('.acl-card'))) return send('product_click', { source: areaOf(el), product: handleFrom(el) });
    if ((el = t.closest('.acl-tile__media'))) { var cap = el.querySelector('.acl-tile__cap'); return send('creator_tile_click', { product: handleFrom(el), detail: cap ? cap.textContent.trim() : '' }); }
    if ((el = t.closest('.acl-arrow'))) return send('rail_arrow', { direction: el.getAttribute('data-dir') === '1' ? 'next' : 'previous' });
    if ((el = t.closest('.acl-hero .acl-btn'))) return send('banner_button', { label: el.textContent.trim() });
    if ((el = t.closest('.acl-sticky'))) return send('floating_button', { label: el.textContent.trim() });
    if ((el = t.closest('.acl-more'))) return send('link_click', { label: el.textContent.trim(), area: areaOf(el) });
    if ((el = t.closest('.acl a'))) return send('link_click', { label: (el.textContent || '').trim().slice(0, 60), area: areaOf(el) });
  }, true);
  document.addEventListener('acl:added', function (e) {
    var d = e.detail || {};
    send('add_to_bag', { value: d.value, currency: d.currency, items: d.count, products: d.handles, variants: d.variants });
  });
  document.addEventListener('acl:add_error', function (e) { send('add_to_bag_error', { message: (e.detail && e.detail.message) || '' }); });
  var sentMs = 0;
  function flush() {
    var total = visibleMs + (visibleSince ? Date.now() - visibleSince : 0);
    var delta = Math.round((total - sentMs) / 1000);
    if (delta < 1) return;
    sentMs = total;
    send('engagement', { engaged_seconds: delta, max_scroll_percent: maxScroll });
  }
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') { if (visibleSince) { visibleMs += Date.now() - visibleSince; visibleSince = 0; } flush(); }
    else visibleSince = Date.now();
  });
  window.addEventListener('pagehide', flush);
})();